import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const languages = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'it', name: 'Italiano', flag: '🇮🇹' },
  { code: 'pt', name: 'Português', flag: '🇧🇷' },
  { code: 'ja', name: '日本語', flag: '🇯🇵' },
  { code: 'ko', name: '한국어', flag: '🇰🇷' },
  { code: 'zh', name: '中文', flag: '🇨🇳' },
  { code: 'ru', name: 'Русский', flag: '🇷🇺' },
];

export const conversionRoutes = [
  { path: '/avif-to-jpg', from: 'avif', to: 'jpeg', key: 'avifToJpg' },
  { path: '/avif-to-png', from: 'avif', to: 'png', key: 'avifToPng' },
  { path: '/avif-to-webp', from: 'avif', to: 'webp', key: 'avifToWebp' },
  { path: '/jpg-to-avif', from: 'jpeg', to: 'avif', key: 'jpgToAvif' },
  { path: '/png-to-avif', from: 'png', to: 'avif', key: 'pngToAvif' },
  { path: '/webp-to-avif', from: 'webp', to: 'avif', key: 'webpToAvif' },
];
